import { render } from "./PingJiaZiYuanApiDataView.vue?vue&type=template&id=638f4991&scoped=true"
import script from "./PingJiaZiYuanApiDataView.vue?vue&type=script&lang=js"
export * from "./PingJiaZiYuanApiDataView.vue?vue&type=script&lang=js"

import "./PingJiaZiYuanApiDataView.vue?vue&type=style&index=0&id=638f4991&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638f4991"]])

export default __exports__